import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ErrorService } from "@modules/common/services/error.service";
import { RedirectToLoginService } from "@modules/common/services/redirect-to-login.service";

@Injectable({
    providedIn: 'root'
})
export class HttpErrorService {
    constructor(
        private _redirectToLoginService: RedirectToLoginService,
        private _errorService: ErrorService
    ) { }

    public handleHttpError(error: HttpErrorResponse) : void {
        if (error.error instanceof Error) {
            this._errorService.registerError({
                errorMessage: error.error.toString()
            });
        } else {
            if (Math.floor(error.status) == 401) {
                this._redirectToLoginService.redirectToLogin();
            } else {
                //Here the error.error property should be the response body,
                //which is a serialized ApiCallError, which matches the
                //ErrorDetails interface.
                if (error.error && error.error.hasOwnProperty('errorMessage')) {
                    this._errorService.registerError(error.error);
                } else {
                    this._errorService.registerError({
                        errorMessage: error.message
                    })
                }
            }
        }
    }
}
